import normalise from '~/lib/normalizeStr';
import find from 'lodash/find';
import uniqWith from 'lodash/uniqWith';
import filter from 'lodash/filter';
import groupBy from 'lodash/groupBy';
import mapValues from 'lodash/mapValues';
import sortBy from 'lodash/sortBy';
import isArray from 'lodash/isArray';

const searchFields = ['title'];

export const flattenGroups = (group, groups) => {
    let entries = [],
        groupEntries = groups[group];

    if(!isArray(groupEntries)) {
        return [];
    }

    for(let entry of groupEntries) {
        entries.push(entry);

        if(entry.id in groups) {
            let nestedEntries = flattenGroups(entry.id, groups);
            for(let nestedEntry of nestedEntries) {
                entries.push(nestedEntry);
            }
        }
    }

    return entries;
};

export const sortEntries = (entries) => {
    // return entries;

    let grouped  = groupBy(entries, 'parentId');

    grouped = mapValues(grouped, (entries) => {
        return sortBy(entries, ['sortOrder', 'title'])
    });

    return flattenGroups(null, grouped);
};

export const normalizeHelpData = (entries) => {
    let normalizedEntries = entries.map((entry) => {
        return {
            id: entry.id.raw,
            parentId: entry.parent_help_article_id.raw,
            sortOrder: entry.sort_order.raw,
            name: entry.name.rendered,
            body: entry.body.rendered,
            title: entry.title.rendered,
            urlPath: entry.urlPath.rendered,
            previewPath: entry.previewPath.rendered,
            type: entry.type.rendered,
            large: entry.is_large.raw,
        }
    });

    let indexed = {};
    for(let entry of normalizedEntries) {
        indexed[entry.name] = entry;
    }

    return {
        entries: sortEntries(normalizedEntries),
        indexed
    }
};

export default function searchHelpData(entries, category, searchTerm, shouldCompleteParents = false) {
    if(category) { category = category.toLowerCase(); }
    if(searchTerm) { searchTerm = searchTerm.toLowerCase(); }

    if((!category || !category.length) && (!searchTerm || searchTerm.length < 1)) {
        return entries;
    }

    const getRecursiveEntries = (entry, entries) => {
        let childEntries = entries.reduce((theChildEntries, theCurrentEntry) => {
            if(theCurrentEntry.parentId !== entry.id) {
                return theChildEntries;
            }

            theChildEntries = [...theChildEntries, theCurrentEntry, ...getRecursiveEntries(theCurrentEntry, entries)];

            return theChildEntries;
        }, []);

        return childEntries;
    };


    const filterByTerm = (entries) => {
        if(!searchTerm || searchTerm.length < 1) { return entries; }

        let filteredEntries = entries.filter((entry) => {
            for(let field of searchFields) {
                let normalized = normalise(entry[field]);
                let isMatching = normalized.indexOf(searchTerm) > -1;

                if(isMatching) { return true; }
            }

            return false;
        });

        let allEntries = [];
        for(let entry of filteredEntries) {
            allEntries = [...allEntries, entry, ...getRecursiveEntries(entry, entries)];
        }

        return allEntries;
    };

    const getRecursiveParents = (entry, entries) => {
        let parents = [];

        let directParent = find(entries, (e) => e.id === entry.parentId);

        if(directParent) {
            parents.push(directParent);
            parents = [...parents, directParent, ...getRecursiveParents(directParent, entries)];
        }

        return parents;
    };

    const completeParents = (entries, allEntries) => {
        let completedParentIds = {};

        return entries.reduce((theEntries, entry) => {
            let entryParentId = entry.parentId;

            if(!entryParentId) { return theEntries; }
            if(entryParentId in completedParentIds) { return theEntries; }

            let parentEntries = getRecursiveParents(entry, allEntries);

            completedParentIds[entry.id] = true;

            for(let parentEntry of parentEntries) {
                completedParentIds[parentEntry.id] = true;

                if(!find(theEntries, e => e.id === parentEntry.id)) {
                    theEntries.push({...parentEntry, completedParent: true});
                }
            }

            return theEntries;
        }, [...entries]);
    };

    const filterByCategory = (entries) => {
        if(!category || !category.length) {
            return entries;
        }

        let categoryEntry = find(entries, (entry) => {
            return entry.name === category;
        });

        if(!categoryEntry) { return []; }
        return [categoryEntry, ...getRecursiveEntries(categoryEntry, entries)];
    };

    let filteredEntries = filterByCategory(entries);
    filteredEntries = completeParents(filteredEntries, entries);
    filteredEntries = filterByTerm(filteredEntries);
    filteredEntries = completeParents(filteredEntries, entries);

    filteredEntries = uniqWith(filteredEntries, (a, b) => {
        return a.id === b.id
    });

    if(shouldCompleteParents) {
        return filteredEntries;
    }

    return filter(filteredEntries, e => !e.completedParent);
}